import StackdriverErrorReporter from "stackdriver-errors-js";
import { track } from "../utils/analytics";

const shouldSendErrorToBackEnd = (errorMessage: string | object) => {
  try {
    const filterMatches: string[] = [
      "Request failed with status code",
      "Looks like Portal takes too long to load.",
      "No authorization token was found",
      "Sorry, please reload your page!",
      "Network Error"
    ];
    return typeof errorMessage === "string"
      ? !filterMatches.some(matchString => errorMessage.includes(matchString))
      : true;
  } catch (err) {
    // oh the irony!
    console.error(err);
    return true;
  }
};

const isHostedEnv = () =>
  ["staging", "production"].includes(process.env.REACT_APP_ENV || "");

/**
 * Initialize the Stackdriver Error Service.
 *   At this point, uncaught exceptions and
 *   uncaught promise exceptions are reported
 *   to stackdriver errors.
 */
(() => {
  if (!isHostedEnv()) {
    return;
  }

  const stackdriverErrorService = new StackdriverErrorReporter();
  stackdriverErrorService.start({
    key: process.env.REACT_APP_STACKDRIVER_ERRORS,
    projectId: `wingspan-${process.env.REACT_APP_ENV}`,
    service: "wingspan-app",
    version: process.env.version
  });

  // override console.error
  const oldConsoleError = console.error.bind(console);

  console.error = function(error: any) {
    if (shouldSendErrorToBackEnd(error.message || error)) {
      track(`Error Occurred`, { contents: error });
      stackdriverErrorService
        .report(error)
        .catch((err: any) => oldConsoleError(err));
    }

    oldConsoleError(...arguments);
  };
})();
